import { IExtrudeFeature } from 'viewer';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IVertexGroup } from '../kb3d-models';
import { Token } from '../token';
import { ALL_GEOMETRY, Feature } from './feature';

@Kb3dModel({
    token: Token.ExtrudeFeature,
})
export class ExtrudeFeature extends Feature implements IExtrudeFeature {
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set(ALL_GEOMETRY);

    size: number;
    capEnd: boolean;
    capStart: boolean;
    vertexGroups: Array<Required<IVertexGroup>> = [];
}
